import { Locale } from '../../../../core/i18n/Locale';
import { generateUrl } from '../../../../shared/utilities/routing/routing';
import { handleResponse } from '../../../shared/types/handlers';

import {
    NormalizedSearchSuggestionsResultFromPWAPI,
    normalizeSearchSuggestionsResponseFromPWAPI,
    SearchSuggestionsResponseFromPWAPI,
} from './normalizers';

export const DEFAULT_SUGGESTIONS_LIMIT = 10;

async function fetchSearchSuggestions({
    locale,
    query,
    limit,
}: {
    locale: Locale;
    query: string;
    limit: number;
}): Promise<SearchSuggestionsResponseFromPWAPI> {
    const response = await fetch(
        generateUrl('api_search_suggestions', locale, {
            q: query,
            locale,
            limit: String(limit),
        }),
    );

    return handleResponse<SearchSuggestionsResponseFromPWAPI>(response);
}

export async function getSearchSuggestions({
    locale,
    query,
    limit = DEFAULT_SUGGESTIONS_LIMIT,
}: {
    locale: Locale;
    query: string;
    limit?: number;
}): Promise<NormalizedSearchSuggestionsResultFromPWAPI> {
    const response = await fetchSearchSuggestions({ locale, query, limit });
    return normalizeSearchSuggestionsResponseFromPWAPI(response);
}
